<template>
  <div id="footer" class="container-fluid">
    <div class="content row">
      <div class="col-md-3 col-sm-3 footer-logo-wrp">
        <img class="footer-logo" src="@/assets/img/logo_white.png" alt="吉时牛微信公众号">
      </div>
      <div class="col-md-3 col-sm-3 hidden-xs">
        <p class="content-div-p" @click="toLInk(item.path)" v-for="(item, index) in aboutUsList" :key="index">{{ item.name }}</p>
      </div>
      <div class="col-md-3 col-sm-3 hidden-xs">
        <p class="content-div-p">
          <span @click="toLInk('/software/couponMall')" class="content-left">产品服务</span>
          <span class="content-right">&emsp;&emsp;&emsp;</span>
        </p>
        <p class="content-div-p">
          <span @click="toLInk('/software/couponMall')" class="content-left">卡券商城</span>
          <span @click="toLInk('/software/aggregatedSupplyChain')" class="content-right">聚合供应链</span>
        </p>
        <p class="content-div-p">
          <span @click="toLInk('/software/welfareMall')" class="content-left">福利商城</span>
          <span @click="toLInk('/software/ownSupplyChain')" class="content-right">自有供应链</span>
        </p>
        <p class="content-div-p">
          <span @click="toLInk('/software/customerServiceHosting')" class="content-left">人工客服托管</span>
          <span class="content-right">&emsp;&emsp;&emsp;</span>
        </p>
      </div>
      <div class="col-md-3 col-sm-3">
        <p class="content-phone">17310656552</p>
        <div class="contact-qr-code">
          <img class="qr-code" src="@/assets/img/qr_code.jpg" alt="吉时牛微信公众号">
          <div>
            <p>扫码关注吉时牛</p>
            <p>官方微信公众号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="copy">
      <a @click="toRef">Copyright &copy; 2022  {{config.name}} {{config.keepOnRecordIcp}}</a>
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502052909">京公网安备 11010502052909号</a>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      config: config,
      aboutUsList: [
        {
          name: '关于我们',
          path: '/aboutUs/companyintroduction'
        },
        {
          name: '公司介绍',
          path: '/aboutUs/companyintroduction'
        },
        {
          name: '联系我们',
          path: '/aboutUs/contactus'
        },
        {
          name: '加入我们',
          path: '/aboutUs/jobchance'
        },
      ],
    };
  },
  methods: {
    toLInk(path) {
      this.$router.push({path: path})
    },
    toRef(){
      window.open('https://beian.miit.gov.cn')
    }
  }
};
</script>
<style scoped>
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}
#footer {
  width: 100%;
  height: 100%;
  color: #99959b;
  background: #17181B;
  overflow: hidden;
  text-align: center;
}
.footer-logo-wrp {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-logo {
  width: 120px;
  height: 100px;
}
.content {
  padding: 30px 0px 0px;
}
.content > div {
  padding: 30px 0px 30px;
  height: 200px;
}
.content-div-p:first-child {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  line-height: 20px;
  letter-spacing: 1px;
  margin-bottom: 20px;
}
.content-div-p {
  margin-bottom: 20px;
  color: #8d9395;
}
.content-div-p:last-child {
  margin-bottom: 0px;
}
.content-left {
  text-align: left;
}
.content-right {
  text-align: left;
  margin-left: 100px;
}
.contact-qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact-qr-code p {
  color: #8d9395;
}
.qr-code {
  width: 80px;
  height: 80px;
  margin-right: 30px;
}
.content-phone {
  font-size: 30px;
  margin-bottom: 20px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  background-color: #474747;
  padding: 20px 20px 10px;
}
a{
  text-decoration: none;
  color: #d3d3d3;
}
@media screen and (max-width: 997px) {
  .copy {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue